import script from "./EcommerceImagenesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceImagenesView.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceImagenesView.vue?vue&type=style&index=0&id=5f2891c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2891c2"]])

export default __exports__